import {
  FieldProps,
  InputOnChangeData,
  SearchBox,
  SearchBoxChangeEvent,
  Field,
  mergeClasses,
} from "@fluentui/react-components";
import { useEffect, useState } from "react";
import { FluentProvider, makeStyles } from "../../";
import {
  SearchFieldCustomLeftWrapper,
  SearchFieldCustomRightWrapper,
  SearchFieldCustomWrapper,
} from "./Style";

interface SearchBoxFieldCustomProps {
  rcName?: string;
  theme?: string;
  rcRole?: string[];
  requireRoles?: string[];
  onSearched?: (newValue: string) => void;
  placeholder?: string;
  timeOut?: number;
  autoFocus?: boolean;
  disabled?: boolean;
  value?: string;
  componentLeft?: React.ReactNode;
}

const useStyles = makeStyles({
  root: {
    fontWeight: 600,
  },
  search: {
    width: "100%",
    maxWidth: "100%",
  },
});

const SearchBoxFieldCustom = (
  props: SearchBoxFieldCustomProps & FieldProps,
) => {
  const styles = useStyles();
  const [typingTimeout, setTypingTimeout] = useState<number>(0);
  const [text, setText] = useState<string>("");

  const timeOut = props.timeOut ? props.timeOut : 1000;

  useEffect(() => {
    if (props.value !== text) {
      setText(props.value || "");
    }
  }, [props.value]);

  const onHandleSearching = (
    _event: SearchBoxChangeEvent,
    data: InputOnChangeData,
  ): void => {
    const value = data?.value || "";
    //setIsLoadingSearch(true)
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    setText(value || "");
    setTypingTimeout(
      window.setTimeout(() => {
        //setIsLoadingSearch(false)
        if (props.onSearched) {
          props.onSearched(value.trim());
        }
      }, timeOut),
    );
  };

  return props.theme ? (
    <FluentProvider theme={props.theme}>
      <Field
        label={props.label}
        validationMessage={props.validationMessage}
        validationMessageIcon={props.validationMessageIcon}
        validationState={props.validationState}
        required={props.required}
        style={props.style}
        className={mergeClasses(props.className, styles.root)}
      >
        {props.componentLeft ? (
          <SearchFieldCustomWrapper>
            <SearchFieldCustomLeftWrapper>
              {props.componentLeft}
            </SearchFieldCustomLeftWrapper>
            <SearchFieldCustomRightWrapper>
              <SearchBox
                onChange={onHandleSearching}
                placeholder={props.placeholder}
                value={text}
                className={styles.search}
                autoFocus={props.autoFocus}
              />
            </SearchFieldCustomRightWrapper>
          </SearchFieldCustomWrapper>
        ) : (
          <SearchBox
            onChange={onHandleSearching}
            placeholder={props.placeholder}
            value={text}
            className={styles.search}
            autoFocus={props.autoFocus}
          />
        )}
      </Field>
    </FluentProvider>
  ) : (
    <Field
      label={props.label}
      validationMessage={props.validationMessage}
      validationMessageIcon={props.validationMessageIcon}
      validationState={props.validationState}
      required={props.required}
      style={props.style}
      className={mergeClasses(props.className, styles.root)}
    >
      {props.componentLeft ? (
        <SearchFieldCustomWrapper>
          <SearchFieldCustomLeftWrapper>
            {props.componentLeft}
          </SearchFieldCustomLeftWrapper>
          <SearchFieldCustomRightWrapper>
            <SearchBox
              onChange={onHandleSearching}
              placeholder={props.placeholder}
              value={text}
              className={styles.search}
              autoFocus={props.autoFocus}
            />
          </SearchFieldCustomRightWrapper>
        </SearchFieldCustomWrapper>
      ) : (
        <SearchBox
          onChange={onHandleSearching}
          placeholder={props.placeholder}
          value={text}
          className={styles.search}
          autoFocus={props.autoFocus}
        />
      )}
    </Field>
  );
};

export default SearchBoxFieldCustom;
